export class NodeElement {

    /**
     * @param node
     * @returns {NodeElement}
     */
    static createFromNode(node) {
        return new NodeElement(node);
    }

    /**
     * @param name
     * @returns {NodeElement}
     */
    static createFromName(name) {
        return new NodeElement(document.createElement(name));
    }

    /**
     * @param html
     * @returns {NodeElement}
     */
    static createFromHtml(html) {
        let temp = document.createElement('div');
        temp.innerHTML = html.trim();

        return new NodeElement(temp.firstChild);
    }

    /**
     * @param node
     */
    constructor(node) {
        this._node = node;
    }

    /**
     * @returns {*}
     */
    node() {
        return this._node;
    }

    /**
     * @param parent
     * @returns {NodeElement}
     */
    attach(parent) {
        if (parent instanceof NodeElement) {
            parent.node().appendChild(this._node);

            return this;
        }

        if (parent instanceof Node) {
            parent.appendChild(this._node);

            return this;
        }

        throw 'Child must be instance of NodeElement or Node!';
    }

    /**
     * @returns {NodeElement}
     */
    detach() {
        if (this._node.parentNode) {
            this._node.parentNode.removeChild(this._node);
        }

        return this;
    }

    /**
     * @param child
     * @returns {NodeElement}
     */
    appendChild(child) {
        if (child instanceof NodeElement) {
            this._node.appendChild(child.node());

            return this;
        }

        if (child instanceof Node) {
            this._node.appendChild(child);

            return this;
        }

        throw 'Child must be instance of NodeElement or Node!';
    }

    /**
     * @param name
     * @param value
     * @returns {NodeElement}
     */
    setProperty(name, value) {
        this._node[name] = value;

        return this;
    }

    /**
     * @param html
     * @returns {NodeElement}
     */
    setInnerHtml(html) {
        this._node.innerHTML = html;

        return this;
    }

    /**
     * @param text
     * @returns {NodeElement}
     */
    setInnerText(text) {
        this._node.innerText = text;

        return this;
    }

    /**
     * @param name
     * @returns {NodeElement}
     */
    addClass(name) {
        this._node.classList.add(name);

        return this;
    }

    /**
     * @param name
     * @returns {NodeElement}
     */
    removeClass(name) {
        this._node.classList.remove(name);

        return this;
    }

    /**
     * @param event
     * @param callback
     * @returns {NodeElement}
     */
    addEventListener(event, callback) {
        this._node.addEventListener(event, callback);

        return this;
    }
}
